import { css } from 'lit';

export const styles = css`
  :host { 
    display: block; 
    min-height: 100vh;
    background: var(--sl-color-neutral-50);
  }

  .page-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 2rem;
  }

  .page-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid var(--sl-color-neutral-200);
  }

  .back-button {
    margin-right: 0.5rem;
  }

  .asset-info { 
    display: flex; 
    align-items: center; 
    gap: 1.5rem; 
    margin-bottom: 2rem;
    background: white;
    padding: 1.5rem;
    border-radius: 12px;
    box-shadow: var(--sl-shadow-medium);
  }

  .asset-image-placeholder {
    width: 120px; 
    height: 120px; 
    background: var(--sl-color-neutral-200); 
    border-radius: 12px;
    display: flex; 
    align-items: center; 
    justify-content: center; 
    border: 2px dashed var(--sl-color-neutral-300);
    cursor: pointer; 
    transition: all .2s ease; 
    position: relative;
    flex-shrink: 0;
  }
  
  .asset-image-placeholder:hover { 
    background: var(--sl-color-neutral-100); 
    border-color: var(--sl-color-primary-400); 
  }
  
  .asset-image-placeholder.uploading { 
    border-color: var(--sl-color-primary-600); 
    background: var(--sl-color-primary-50); 
  }
  
  .asset-image-placeholder img { 
    width: 100%; 
    height: 100%; 
    object-fit: cover; 
    border-radius: 10px; 
  }

  .upload-overlay { 
    position: absolute; 
    inset: 0; 
    background: rgba(0,0,0,.7); 
    display: flex; 
    align-items: center; 
    justify-content: center; 
    border-radius: 10px; 
    opacity: 0; 
    transition: opacity .2s ease; 
  }
  
  .asset-image-placeholder:hover .upload-overlay { 
    opacity: 1; 
  }
  
  .upload-overlay sl-icon { 
    color: white; 
    font-size: 2rem; 
  }

  .asset-details { 
    flex: 1; 
  }
  
  .asset-name { 
    font-size: 1.75rem; 
    font-weight: 600; 
    margin-bottom: 0.5rem; 
    color: var(--sl-color-neutral-900); 
  }
  
  .asset-location { 
    font-size: 1rem; 
    color: var(--sl-color-neutral-600);
    margin-bottom: 0.25rem;
  }
  
  .header-qr-code {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 0.75rem;
  }

  .content-area {
    background: white;
    border-radius: 12px;
    box-shadow: var(--sl-shadow-medium);
    overflow: hidden;
  }

  sl-tab-group {
    --indicator-color: var(--sl-color-primary-600);
  }

  .info-description { 
    color: var(--sl-color-neutral-600); 
    margin-bottom: 1.5rem; 
    font-size: 0.875rem; 
  }

  .field-row { 
    display: flex; 
    align-items: center; 
    gap: 1rem; 
    margin-bottom: 1rem; 
    padding: 0.75rem; 
    background: var(--sl-color-neutral-50); 
    border-radius: 8px; 
  }
  
  .field-label { 
    min-width: 120px; 
    font-weight: 600; 
    color: var(--sl-color-neutral-700); 
  }
  
  .field-value { 
    flex: 1; 
    display: flex; 
    align-items: center; 
    gap: 0.5rem; 
  }
  
  .field-value sl-input, 
  .field-value sl-select { 
    flex: 1; 
    min-width: 200px; 
  }

  .action-bar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.75rem;
    padding: 1.5rem;
    background: var(--sl-color-neutral-50);
    border-top: 1px solid var(--sl-color-neutral-200);
  }

  .data-table-container { 
    overflow-x: auto; 
  }
  
  .data-table { 
    width: 100%; 
    border-collapse: collapse; 
  }
  
  .data-table th, 
  .data-table td { 
    padding: 0.75rem; 
    text-align: left; 
    border-bottom: 1px solid var(--sl-color-neutral-200); 
  }
  
  .data-table th { 
    font-weight: 600; 
    color: var(--sl-color-neutral-600); 
    font-size: 0.9rem;
    background: var(--sl-color-neutral-50);
  }
  
  .data-table td { 
    color: var(--sl-color-neutral-900); 
    font-size: 0.9rem; 
  }

  .data-table tbody tr {
    transition: background-color 0.2s ease;
  }

  .data-table tbody tr:hover {
    background: var(--sl-color-neutral-50);
    cursor: pointer;
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }

  .error-container {
    padding: 2rem;
    text-align: center;
  }
`;

